<template>
	<div class="default-loader">
		<span class="loader">
			<span class="r r1"></span>
			<span class="r r2"></span>
			<span class="r r3"></span>
			<span class="r r4"></span>
			<span class="r r5"></span>
 			<span class="logo">
				<svg-sprite width="130" height="31" icon-id="logo"></svg-sprite>
			</span>
		</span>
	</div>
</template>

<script>
export default {
	name: "default-loader"
};
</script>

<style scoped lang="scss">
.default-loader {
	.loader {
		display: block;
		position: relative;
		width: 130px;
		width: 300px;
		height: 100px;
		background-repeat: no-repeat;

		//background-image: linear-gradient( var(--base-green-dark), var(--base-green-dark) ),
		//linear-gradient( var(--base-green), var(--base-green) ), linear-gradient( var(--base-green), var(--base-green) );
		//background-size: 80px 70px, 30px 50px, 30px 30px;
		//background-position: 0 0, 80px 20px, 100px 40px;

		background-image:
				linear-gradient(#003f4e, #203c85),
				linear-gradient(#045100, #319538),
				linear-gradient(var(--base-green-dark), var(--base-green-dark)),
				linear-gradient(var(--base-green), var(--base-green)),
				linear-gradient(var(--base-green), var(--base-green));
		background-size:
				26px 17px,
				215px 50px,
				220px 15px,
				40px 50px,
				200px 30px;
		background-position:
				227px 27px,
				0px 0px,
				0px 55px,
				220px 20px,
				220px 40px;
		//&:after {
		//	content: "";
		//	position: absolute;
		//	bottom: 10px;
		//	left: 12px;
		//	width: 10px;
		//	height: 10px;
		//	background: #fff;
		//	border-radius: 50%;
		//	box-sizing: content-box;
		//	border: 10px solid #000;
		//	box-shadow: 78px 0 0 -10px #fff, 78px 0 #000;
		//	animation: wheelSk 0.75s ease-in infinite alternate;
		//}
		.r {
			position: absolute;
			bottom: 14px;
			width: 8px;
			height: 8px;
			background: #fff;
			border-radius: 50%;
			box-sizing: content-box;
			border: 8px solid #000;
			animation: wheelSk 1.2s ease-in-out infinite;

			&.r5 {
				left: 12px;
				animation-delay: 0s;
			}

			&.r4 {
				left: 40px;
				animation-delay: 0.09s;
			}

			&.r3 {
				left: 154px;
				animation-delay: 0.45s;
			}

			&.r2 {
				left: 182px;
				animation-delay: 0.54s;
			}

			&.r1 {
				left: 266px;
				animation-delay: 0.8s;
			}
		}

		@keyframes wheelSk {
			0%, 100% {
				transform: translateY(0);
			}
			20% {
				transform: translateY(-2px);
			}
			40% {
				transform: translateY(-4px);
			}
			60% {
				transform: translateY(-2px);
			}
			80% {
				transform: translateY(0);
			}
		}
		.logo {
			position: absolute;
			top: 10px;
			left: 40px;
			width: 127px;
			height: 30px;
		}

		&:before {
			content: "";
			position: absolute;
			right: 100%;
			top: 0px;
			height: 70px;
			width: 70px;
			background-image: linear-gradient(#fff 45px, transparent 0),
			linear-gradient(#fff 45px, transparent 0),
			linear-gradient(#fff 45px, transparent 0);
			background-repeat: no-repeat;
			background-size: 30px 4px;
			background-position: 0px 11px, 8px 35px, 0px 60px;
			animation: lineDropping 0.75s linear infinite;
		}
	}
}

@keyframes wheelSk {
	0%, 50%, 100% { transform: translatey(0) }
	30%, 90% { transform: translatey(-3px) }
}

@keyframes lineDropping {
	0% {
		background-position: 100px 11px, 115px 35px, 105px 60px;
		opacity: 1;
	}
	50% { background-position: 0px 11px, 20px 35px, 5px 60px }
	60% { background-position: -30px 11px, 0px 35px, -10px 60px }
	75%, 100% {
		background-position: -30px 11px, -30px 35px, -30px 60px;
		opacity: 0;
	}
}
</style>
